import { Button, CircularProgress, Menu, MenuItem } from '@mui/material';
import { useState } from 'react';
import Iconify from '../iconify';

const ManyButton = ({ nameMain, listButton, startIcon }) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const [loading, setLoading] = useState(false);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget); // mở menu ngay dưới nút bấm
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    return (
        <>
            <Button
                variant="contained"
                disabled={loading}
                startIcon={!loading && startIcon}
                onClick={handleClick}
                sx={{ position: 'relative' }}
            >
                {nameMain}
                {loading && (
                    <CircularProgress
                        size={24}
                        sx={{
                            color: 'white',
                            position: 'absolute',
                            top: '50%',
                            left: '50%',
                            marginTop: '-12px',
                            marginLeft: '-12px',
                        }}
                    />
                )}
            </Button>

            <Menu
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                }}
            >
                {listButton?.map((btn, idx) => (
                    <MenuItem key={idx} disableGutters sx={{ p: 0 }}>
                        <Button
                            fullWidth
                            variant={btn.variant || 'text'}
                            component={btn.component}
                            target={btn.target}
                            download={btn.download}
                            to={btn.to}
                            href={btn.href}
                            onClick={() => {
                                handleClose();

                                if (btn.htmlFor) {
                                    // click vào input hidden
                                    const input = document.getElementById(btn.htmlFor);
                                    if (input) input.click();
                                }

                                btn.onClick?.();
                            }}
                            sx={{
                                minWidth: "150px",
                                p: 1
                            }}
                        >
                            {btn.label}
                        </Button>
                    </MenuItem>
                ))}
            </Menu>
        </>
    );
};

export default ManyButton;
